import { formatPrice } from '@/utils/formatters.ts';
import { pluralForm, pluralize } from '@/utils/pluralize.ts';
import { TourOptionOccupancyDto } from '@/features/dashboard/tours/types/dashboard/dto/TourOptionOccupancyDto.ts';

/** Podpis opcji: „3 warianty · 220,00 zł”. Opcja bez cennika gubi człon ceny. */
export const optionMetaLabel = (option: TourOptionOccupancyDto): string =>
  [
    pluralize(option.variants.length, 'wariant', 'warianty', 'wariantów'),
    option.price && formatPrice(option.price.amount, option.price.currency),
  ]
    .filter(Boolean)
    .join(' · ');

/** Ile osób przeszło przez filtry i dlaczego akurat tyle. */
export const filterResultNote = (filterCount: number): string => {
  if (filterCount === 0) return 'bez filtrów — wszyscy uczestnicy wyjazdu';
  if (filterCount === 1) return 'spełnia zaznaczony warunek';
  return `spełnia wszystkie ${filterCount} ${pluralForm(filterCount, 'zaznaczony', 'zaznaczone', 'zaznaczonych')} ${pluralForm(filterCount, 'warunek', 'warunki', 'warunków')}`;
};
